export const getFullDate = (
  formattingDate: Date | string,
  monthFormat?: '2-digit' | 'long' | 'narrow' | 'numeric' | 'short',
) => {
  const date = new Date(formattingDate);
  const year = date.getFullYear().toString();
  const [month] = date
    .toLocaleString('en-us', {
      month: monthFormat || 'long',
    })
    .split(' ');
  const day = date.getDate().toString();
  return [day, month, year];
};
